import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { setBreadCrumbs } from '../actions/breadcrumbs.js';
import Loader from 'react-loader-advanced';
import PropTypes from 'prop-types';
import { getEmDataColletionBySessionId } from '../api/ispyb.js';
import { GridSquarePanel } from '../components/Em/GridSquarePanel';
import { GridPanel } from '../components/Em/GridPanel';
import {  Grid, Row, Col } from 'react-bootstrap';


class EmSessionsContainer extends Component {
  constructor(props) {
      super(props); 
      
      this.state = { 
          fetching : true,
          fetched : false,          
          dataCollections : [],
          error : null
    };
  }


  /**
   * This method will retrieve the dataCollections for a given session   
   */
  componentDidMount(){   
    var _this = this; 

    axios({
        method: 'GET',
        url: getEmDataColletionBySessionId(this.props.user, this.props.proposal, this.props.sessionId),            
    })
    .then(function (response) {  
        console.log(response.data)  
        for (var i = 0; i < response.data.length; i++){
            if (!response.data[i].stats){
                response.data[i].stats = [];
            }
        }   
        _this.setState({
            dataCollections : response.data,
            fetching : false,
            fetched : true
        });        
    })
    .catch(function (error) {                    
        _this.setState({
            error : error,
            fetching : false,
            fetched : false
        });
    });
  }

  render() {      
    if ((!this.props.user) || (!this.props.user.token)) {         
      return null;
    }
    return (
      <div style={{marginBottom : '100px'}}>
        <Loader show={this.state.fetching} >
            <Grid fluid>
                    {this.state.dataCollections.map((value, index) => {
                            return <div key={index}>
                                    <Row>
                                      <GridPanel
                                          startTimeList={value["startTimeList" ]}
                                          sampleName = {value["BLSample_name"]}                                                
                                          voltageList = {value["voltageList"]}
                                          gridSquaresCount = {value["totalNumberOfDataCollections"]}
                                          framesCount = {value["imagesCount"]}
                                          samplingRate = {value["DataCollection_xBeamPix"]} 
                                          voltage = {value["DataCollection_voltage"]}
                                          magnificationList = {value["magnificationList"]}
                                          dataCollectionIdList = {value["dataCollectionIdList"]}
                                          stats = {value["stats"]}
                                          imageDirectoryList = {value["imageDirectoryList"]}
                                          user={this.props.user}
                                          proposal={this.props.proposal}
                                          sessionId={this.props.sessionId}>
                                      </GridPanel>
                                  </Row>
                                  </div>
                        })}   
            </Grid>     
        </Loader>        
      </div>);
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {  
    setBreadCrumbs: (breadCrumbs) => dispatch(setBreadCrumbs(breadCrumbs))    
  };
}

EmSessionsContainer.propTypes = {
  sessionId: PropTypes.string,
  proposal: PropTypes.string  
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmSessionsContainer);










// WEBPACK FOOTER //
// ./src/containers/EmSessionContainer.js